import React, { useState }  from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button } from '@mui/material';
import AlarmContacts from './AlarmContacts'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { AlarmContactsHandle } from '../Alarm Functions/AlarmOverviewFunctions'
import { FormattedMessage } from 'react-intl';

interface Props {
    showContacts: boolean
    toggleContactModal: () => void
    companyId: number | null
    closeContactModal: () => void
}





const AlarmContactModal: React.FC<Props> = ({ showContacts, toggleContactModal, companyId, closeContactModal }) => {
    //handles rendering the alarm conacts component in modal form for device overview

    const [triggerSave, setTriggerSave] = useState<boolean | null>(false)


  

    const handleSaveComplete = (): void => {
        setTriggerSave(false)
        toggleContactModal()
    }


    return (
        <Modal
            show={showContacts}
            style={{
                transform: 'translate(12.5vw,2vh)',
                zIndex: 10000000000
               
            }}
            className='modal-75w'
        >
            <Modal.Header>
                <Modal.Title><FormattedMessage id="Set / edit how recipients will receive alarms" /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AlarmContacts
                    triggerSave={triggerSave}
                    onSaveComplete={handleSaveComplete}
                    companyId={companyId}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='contained' color='error' onClick={(): void => closeContactModal()}><FormattedMessage id="Cancel" /></Button>
                <Button variant='contained' style={{ marginLeft: 10 }} color='primary' onClick={(): void => setTriggerSave(true)}><FormattedMessage id="Save" /></Button>
            </Modal.Footer>
        </Modal>
    )
}
export default AlarmContactModal